import bg_1 from '../../public/assets/lowRes/1_bg.png';
import bg_2 from '../../public/assets/lowRes/2_bg.png';
import bg_3 from '../../public/assets/lowRes/3_bg.png';
import bg_4 from '../../public/assets/lowRes/4_bg.png';
import bg_5 from '../../public/assets/lowRes/5_bg.png';

export const BackgroundLowRes = ({ level }: { level: number }) => {
  const backgrounds = [bg_1, bg_2, bg_3, bg_4, bg_5];

  level = Math.min(level, 4);

  return <img className='h-[70px] w-[70px]' src={backgrounds[level]} />;
};
